import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.map.js";
var learningPermissions = [{
  key: 'asset',
  label: 'permission_asset'
}, {
  key: 'playlist',
  label: 'permission_playlist'
}, {
  key: 'nudge',
  label: 'permission_nudge'
}];
var allPermissions = [{
  key: 'user',
  label: 'permission_user'
}, {
  key: 'report',
  label: 'permission_report'
}];
var helixPermission = [{
  key: 'helix',
  label: 'permission_helix'
}];
export var EDITABLE_PERMISSIONS_MAP = {
  learning: [].concat(learningPermissions, allPermissions),
  helix: [].concat(allPermissions, helixPermission),
  both: [].concat(learningPermissions, allPermissions, helixPermission)
};
export var EDITABLE_PERMISSION_KEYS_MAP = Object.entries(EDITABLE_PERMISSIONS_MAP).reduce(function (acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    mode = _ref2[0],
    perms = _ref2[1];
  acc[mode] = perms.map(function (perm) {
    return perm.key;
  });
  return acc;
}, {});
export var PERMISSION_KEYS = [].concat(_toConsumableArray(EDITABLE_PERMISSION_KEYS_MAP.both), ['settings']);
export var SUPER_USER = 'super';
export var ROLE_OWNER = 'owner';
export var SETTINGS_READ = 'settings_read';
export var SETTINGS_WRITE = 'settings_write';
export var USER_WRITE = 'user_write';
export var USER_READ = 'user_read';
export var REPORT_WRITE = 'report_write';
export var REPORT_READ = 'report_read';
export var NUDGE_WRITE = 'nudge_write';
export var NUDGE_READ = 'nudge_read';
export var PLAYLIST_WRITE = 'playlist_write';
export var PLAYLIST_READ = 'playlist_read';
export var ASSET_WRITE = 'asset_write';
export var ASSET_READ = 'asset_read';
export var HELIX_WRITE = 'helix_write';
export var HELIX_READ = 'helix_read';
export var lineManagerTeamTypeRoles = ['manager-email', 'manager-employeeid'];